import cabine from '../../../services/cabineApi';
import { gotErrorFromApi } from '../../../utils/api';
import store from '../../configureStore';
import {
  displayBoletoFares,
  getBoletoFaresFromApi,
  gotBoletoFaresFromApi,
  gotErrorFromBoletoFaresApi,
  setAccountBoletosFares,
} from '../../duck/legado/faresApp/boletosFares';
import {
  displayCartaoFares,
  getCartaoFaresFromApi,
  gotCartaoFaresFromApi,
  gotCartaoFaresPartnerFromApi,
  gotErrorFromCartaoFaresApi,
} from '../../duck/legado/faresApp/cartaoFares';
import {
  displayCriptoFares,
  getCriptoFaresFromApi,
  gotCriptoFaresFromApi,
  gotCriptoFaresPartnerFromApi,
  gotErrorFromCriptoFaresApi,
} from '../../duck/legado/faresApp/criptoFares';
import {
  displayDomicilioFares,
  getDomicilioFaresFromApi,
  gotDomicilioFaresFromApi,
  gotDomicilioFaresPartnerFromApi,
  gotErrorFromDomicilioFaresApi,
} from '../../duck/legado/faresApp/domicilioFares';
import {
  setAccountFilterOptions,
  setFareFilterOptions,
  setFinalDateFilterOptions,
  setInitialDateFilterOptions,
  setPartnerFilterOptions,
  setSearched,
  settingFilter,
} from '../../duck/legado/faresApp/filter';
import {
  displayIncomeFares,
  getIncomeFaresFromApi,
  gotErrorFromIncomeFaresApi,
  gotIncomeFaresFromApi,
} from '../../duck/legado/faresApp/Income';
import {
  displayMonthlyFares,
  getMonthlyFaresFromApi,
  gotErrorFromMonthlyFaresApi,
  gotMonthlyFaresFromApi,
} from '../../duck/legado/faresApp/monthlyFares';
import {
  displayPixFares,
  getPixFaresFromApi,
  gotErrorFromPixFaresApi,
  gotPixFaresFromApi,
} from '../../duck/legado/faresApp/pixFares';
import {
  displaySlbFares,
  getSlbFaresFromApi,
  gotErrorFromSlbFaresApi,
  gotSlbFaresFromApi,
} from '../../duck/legado/faresApp/slbFares';
import {
  displayTedFares,
  getTedFaresFromApi,
  gotErrorFromTedFaresApi,
  gotTedFaresFromApi,
} from '../../duck/legado/faresApp/tedFares';
import {
  displayTevFares,
  getTevFaresFromApi,
  gotErrorFromTevFaresApi,
  gotTevFaresFromApi,
  gotTevFaresPartnerFromApi,
} from '../../duck/legado/faresApp/tevFares';
import {
  displayTibFares,
  getTibFaresFromApi,
  gotErrorFromTibFaresApi,
  gotTibFaresFromApi,
} from '../../duck/legado/faresApp/tibFares';
import { SendLoginTokenAuth } from '../tokens';
import {
  IGetBoletoFaresFetchActions,
  IGetCartaoFaresFetchActions,
  IGetCriptoFaresFetchActions,
  IGetDomicilioFaresFetchActions,
  IGetMonthlyFaresFetchActions,
  IGetPixFaresFetchActions,
  IGetSlbFaresFetchActions,
  IGetTedFaresFetchActions,
  IGetTevFaresFetchActions,
  IGetTibFaresFetchActions,
} from './interfaces/faresApp';

export function getTedFares(props: IGetTedFaresFetchActions) {
  return (dispatch: any) => {
    dispatch(getTedFaresFromApi());
    cabine
      .get(
        `/v1/legado/consulta/tarifa/ted/${props.partner}/${props.initialDate}/${props.finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        dispatch(gotTedFaresFromApi(response.data.value));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromTedFaresApi);
      });
  };
}

export function getBoletoFares(props: IGetBoletoFaresFetchActions) {
  return (dispatch: any) => {
    dispatch(getBoletoFaresFromApi());
    cabine
      .get(
        `/v1/legado/consulta/tarifa/boleto/${props.accountType}/${props.partner}/${props.initialDate}/${props.finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        dispatch(setAccountBoletosFares(props.accountType));
        dispatch(gotBoletoFaresFromApi(response.data.value));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromBoletoFaresApi);
      });
  };
}

export function getMonthlyFares(props: IGetMonthlyFaresFetchActions) {
  return (dispatch: any) => {
    dispatch(getMonthlyFaresFromApi());
    cabine
      .get(
        `/v1/legado/consulta/tarifa/mensalidade/${props.accountType}/${props.partner}/${props.initialDate}/${props.finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        dispatch(gotMonthlyFaresFromApi(response.data.value));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromMonthlyFaresApi);
      });
  };
}

export function getTibFares(props: IGetTibFaresFetchActions) {
  return (dispatch: any) => {
    dispatch(getTibFaresFromApi());
    cabine
      .get(
        `/v1/legado/consulta/tarifa/tib/${props.initialDate}/${props.finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        dispatch(gotTibFaresFromApi(response.data.value));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromTibFaresApi);
      });
  };
}

export function getSlbFares(props: IGetSlbFaresFetchActions) {
  return (dispatch: any) => {
    dispatch(getSlbFaresFromApi());
    cabine
      .get(
        `/v1/legado/consulta/tarifa/slb/${props.initialDate}/${props.finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        dispatch(gotSlbFaresFromApi(response.data.value));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromSlbFaresApi);
      });
  };
}

export function getPixFares(props: IGetPixFaresFetchActions) {
  return (dispatch: any) => {
    dispatch(getPixFaresFromApi());
    cabine
      .get(
        `/v1/legado/consulta/tarifa/pix/${props.partner}/${props.initialDate}/${props.finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        dispatch(gotPixFaresFromApi(response.data.value));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromPixFaresApi);
      });
  };
}

export function getCriptoFares(props: IGetCriptoFaresFetchActions) {
  return (dispatch: any) => {
    dispatch(getCriptoFaresFromApi());
    cabine
      .get(
        `/v1/legado/consulta/tarifa/cripto/${props.partner}/${props.initialDate}/${props.finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        if (props.partner !== '1') {
          dispatch(gotCriptoFaresPartnerFromApi(response.data.value));
        } else {
          dispatch(gotCriptoFaresFromApi(response.data.value));
        }
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromCriptoFaresApi);
      });
  };
}

export function getCartaoFares(props: IGetCartaoFaresFetchActions) {
  return (dispatch: any) => {
    dispatch(getCartaoFaresFromApi());
    cabine
      .get(
        `/v1/legado/consulta/tarifa/cartao/${props.partner}/${props.initialDate}/${props.finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        if (props.partner !== '1') {
          dispatch(gotCartaoFaresPartnerFromApi(response.data.value));
        } else {
          dispatch(gotCartaoFaresFromApi(response.data.value));
        }
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromCartaoFaresApi);
      });
  };
}

export function getDomicilioFares(props: IGetDomicilioFaresFetchActions) {
  return (dispatch: any) => {
    dispatch(getDomicilioFaresFromApi());
    cabine
      .get(
        `/v1/legado/consulta/tarifa/domicilio/${props.partner}/${props.initialDate}/${props.finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        if (props.partner !== '1') {
          dispatch(gotDomicilioFaresPartnerFromApi(response.data.value));
        } else {
          dispatch(gotDomicilioFaresFromApi(response.data.value));
        }
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromDomicilioFaresApi);
      });
  };
}
export function getTevFares(props: IGetTevFaresFetchActions) {
  return (dispatch: any) => {
    dispatch(getTevFaresFromApi());
    cabine
      .get(
        `/v1/legado/consulta/tarifa/tev/${props.partner}/${props.initialDate}/${props.finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        if (props.partner !== '1') {
          dispatch(gotTevFaresPartnerFromApi(response.data.value));
        } else {
          dispatch(gotTevFaresFromApi(response.data.value));
        }
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromTevFaresApi);
      });
  };
}

export function getIncomeFares(props: IGetMonthlyFaresFetchActions) {
  return (dispatch: any) => {
    dispatch(getIncomeFaresFromApi());
    cabine
      .get(
        `v1/legado/consulta/receita/${props.partner}/${props.initialDate}/${props.finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        response.data.receita.data_pesquisa = {};
        response.data.receita.data_pesquisa.de = props.initialDate;
        response.data.receita.data_pesquisa.ate = props.finalDate;
        dispatch(gotIncomeFaresFromApi(response.data.receita));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromIncomeFaresApi);
      });
  };
}

export function setPartnerOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setPartnerFilterOptions(props));
  };
}

export function setFareOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setFareFilterOptions(props));
  };
}

export function setAccountOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setAccountFilterOptions(props));
  };
}

export function setInitialDateOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setInitialDateFilterOptions(props));
  };
}

export function setFinalDateOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setFinalDateFilterOptions(props));
  };
}

export function displayFaresAppDashboard(
  fare: string,
  partner: string,
  account: string,
  initialDate: string,
  finalDate: string
) {
  const searched = {
    fare,
    partner,
    account,
    initialDate,
    finalDate,
  };
  store.dispatch(setSearched(searched));
  switch (fare) {
    case 'ted':
      return (dispatch: any) => {
        dispatch(displayPixFares(false));
        dispatch(displayBoletoFares(false));
        dispatch(displayMonthlyFares(false));
        dispatch(displayTibFares(false));
        dispatch(displaySlbFares(false));
        dispatch(displayIncomeFares(false));
        dispatch(displayCriptoFares(false));
        dispatch(displayTevFares(false));
        dispatch(displayCartaoFares(false));
        dispatch(displayDomicilioFares(false));
      };

    case 'boleto':
      return (dispatch: any) => {
        dispatch(displayCartaoFares(false));
        dispatch(displayPixFares(false));
        dispatch(displayCriptoFares(false));
        dispatch(displayTevFares(false));
        dispatch(displayTedFares(false));
        dispatch(displayMonthlyFares(false));
        dispatch(displayTibFares(false));
        dispatch(displaySlbFares(false));
        dispatch(displayIncomeFares(false));
        dispatch(displayDomicilioFares(false));
      };

    case 'mensalidade':
      return (dispatch: any) => {
        dispatch(displayCriptoFares(false));
        dispatch(displayCartaoFares(false));
        dispatch(displayPixFares(false));
        dispatch(displayBoletoFares(false));
        dispatch(displayTedFares(false));
        dispatch(displayTibFares(false));
        dispatch(displaySlbFares(false));
        dispatch(displayTevFares(false));
        dispatch(displayIncomeFares(false));
        dispatch(displayDomicilioFares(false));
      };

    case 'tib':
      return (dispatch: any) => {
        dispatch(displayCartaoFares(false));
        dispatch(displayCriptoFares(false));
        dispatch(displayPixFares(false));
        dispatch(displayMonthlyFares(false));
        dispatch(displayBoletoFares(false));
        dispatch(displayTedFares(false));
        dispatch(displaySlbFares(false));
        dispatch(displayTevFares(false));
        dispatch(displayIncomeFares(false));
        dispatch(displayDomicilioFares(false));
      };

    case 'slb':
      return (dispatch: any) => {
        dispatch(displayCriptoFares(false));
        dispatch(displayPixFares(false));
        dispatch(displayTibFares(false));
        dispatch(displayCartaoFares(false));
        dispatch(displayMonthlyFares(false));
        dispatch(displayBoletoFares(false));
        dispatch(displayTedFares(false));
        dispatch(displayTevFares(false));
        dispatch(displayDomicilioFares(false));
        dispatch(displayIncomeFares(false));
      };

    case 'pix':
      return (dispatch: any) => {
        dispatch(displayPixFares(false));
        dispatch(displayCriptoFares(false));
        dispatch(displayCartaoFares(false));
        dispatch(displayTibFares(false));
        dispatch(displayDomicilioFares(false));
        dispatch(displayMonthlyFares(false));
        dispatch(displayBoletoFares(false));
        dispatch(displayTedFares(false));
        dispatch(displayTevFares(false));
        dispatch(displayIncomeFares(false));
      };

    case 'receita':
      return (dispatch: any) => {
        dispatch(displayPixFares(false));
        dispatch(displayCartaoFares(false));
        dispatch(displayDomicilioFares(false));
        dispatch(displayCriptoFares(false));
        dispatch(displayPixFares(false));
        dispatch(displayTibFares(false));
        dispatch(displayMonthlyFares(false));
        dispatch(displayBoletoFares(false));
        dispatch(displayTedFares(false));
        dispatch(displaySlbFares(false));
        dispatch(displayTevFares(false));
      };

    case 'cripto':
      return (dispatch: any) => {
        dispatch(displayCartaoFares(false));
        dispatch(displayPixFares(false));
        dispatch(displayTibFares(false));
        dispatch(displayMonthlyFares(false));
        dispatch(displayIncomeFares(false));
        dispatch(displayBoletoFares(false));
        dispatch(displayDomicilioFares(false));
        dispatch(displayTedFares(false));
        dispatch(displayTevFares(false));
        dispatch(displaySlbFares(false));
      };

    case 'cartao':
      return (dispatch: any) => {
        dispatch(displayCriptoFares(false));
        dispatch(displayPixFares(false));
        dispatch(displayDomicilioFares(false));
        dispatch(displayTibFares(false));
        dispatch(displayIncomeFares(false));
        dispatch(displayMonthlyFares(false));
        dispatch(displayBoletoFares(false));
        dispatch(displayTevFares(false));
        dispatch(displayTedFares(false));
        dispatch(displaySlbFares(false));
      };

    case 'domicilio':
      return (dispatch: any) => {
        dispatch(displayCartaoFares(false));
        dispatch(displayCriptoFares(false));
        dispatch(displayIncomeFares(false));
        dispatch(displayPixFares(false));
        dispatch(displayTibFares(false));
        dispatch(displayMonthlyFares(false));
        dispatch(displayBoletoFares(false));
        dispatch(displayTedFares(false));
        dispatch(displaySlbFares(false));
        dispatch(displayTevFares(false));
      };

    case 'tev':
      return (dispatch: any) => {
        dispatch(displayCartaoFares(false));
        dispatch(displayDomicilioFares(false));
        dispatch(displayCriptoFares(false));
        dispatch(displayIncomeFares(false));
        dispatch(displayPixFares(false));
        dispatch(displayTibFares(false));
        dispatch(displayMonthlyFares(false));
        dispatch(displayBoletoFares(false));
        dispatch(displayTedFares(false));
        dispatch(displaySlbFares(false));
      };

    default:
      break;
  }
  return null;
}
